import { setupFilters } from './filters';

setupFilters();
